import { useMemo } from "react";
import { useInfringementsQuery } from "@/lib/queries";
import { useDashboardFilter } from "@/contexts/DashboardFilterContext";
import type { Infringement, InfringementSourceAntiPiracy } from "@/types/domain";

export interface FilteredInfringements {
  infringements: Infringement[];
  totalCount: number;
  isPending: boolean;
  isFiltered: boolean;
}

// Infringements filtered by active DashboardFilters
export function useFilteredInfringements(): FilteredInfringements {
  const { filters, hasActiveFilters, dateRange } = useDashboardFilter();
  const { data, isPending } = useInfringementsQuery({
    lastseen_from: dateRange.from?.toISOString(),
    lastseen_to: dateRange.to?.toISOString(),
  });

  const infringements = useMemo(() => {
    const all = data?.infringements ?? [];
    if (!hasActiveFilters) return all;

    let items = all;

    if (filters.infringementType) {
      items = items.filter((i) => i.infringement_type === filters.infringementType);
    }

    if (filters.pirateService) {
      items = items.filter(
        (i) => (i.details as InfringementSourceAntiPiracy).pirate_service === filters.pirateService,
      );
    }

    return items;
  }, [data, filters, hasActiveFilters]);

  return {
    infringements,
    totalCount: data?.infringements.length ?? 0,
    isPending,
    isFiltered: hasActiveFilters,
  };
}
